// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.modal {
  background-color: rgba(0, 0, 0, 0.5);
}

input,
select {
  background-color: #e4e6ef !important ;
  outline: none;
}

body .react-datepicker__input-container input {
  border: 0 !important;
  font-size: 12px;
  height: 34px;
  padding: 10px;
  color: #5e6278;
  border-radius: 4px;
}

body .react-datepicker__input-container input:hover {
  outline: none;
}

body .react-datepicker__input-container input:out-of-range {
  outline: none;
}

.login-title {
  font-size: 32px;
}

.login-form {
  margin-top: 100px !important;
  width: 30%;
}

.dashboard {
  flex-wrap: wrap;
}

.dashboard .col-item {
  flex: 1 1;
}

.dashboard-menu {
  display: none;
}

@media only screen and (max-width: 768px) {
  .login-form {
    transform: translateY(30%);
    width: 90%;
    margin-top: 0px !important;
  }

  .login-title {
    font-size: 24px;
  }

  .dashboard .col-item {
    flex: 1 0 100%;
  }

  .filter-item {
    flex-direction: column;
    margin-bottom: 12px !important;
  }

  .filter-item span {
    display: none;
  }

  .filter-reset {
    display: none;
  }

  .table-transaction {
    overflow-x: auto;
  }

  .dashboard-chart {
    display: none;
  }

  .dashboard-menu {
    display: flex;
  }

  .dashboard-menu button:hover {
    color: #fff;
  }

  .dashboard-menu button.active {
    color: #fff;
  }

  .dashboard-menu button {
    font-size: 16px;
    width: 140px;
    margin-bottom: 12px;
    text-transform: uppercase;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,0BAA0B;IAC1B,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;EAC3B;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.modal {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\ninput,\nselect {\n  background-color: #e4e6ef !important ;\n  outline: none;\n}\n\nbody .react-datepicker__input-container input {\n  border: 0 !important;\n  font-size: 12px;\n  height: 34px;\n  padding: 10px;\n  color: #5e6278;\n  border-radius: 4px;\n}\n\nbody .react-datepicker__input-container input:hover {\n  outline: none;\n}\n\nbody .react-datepicker__input-container input:out-of-range {\n  outline: none;\n}\n\n.login-title {\n  font-size: 32px;\n}\n\n.login-form {\n  margin-top: 100px !important;\n  width: 30%;\n}\n\n.dashboard {\n  flex-wrap: wrap;\n}\n\n.dashboard .col-item {\n  flex: 1;\n}\n\n.dashboard-menu {\n  display: none;\n}\n\n@media only screen and (max-width: 768px) {\n  .login-form {\n    transform: translateY(30%);\n    width: 90%;\n    margin-top: 0px !important;\n  }\n\n  .login-title {\n    font-size: 24px;\n  }\n\n  .dashboard .col-item {\n    flex: 1 0 100%;\n  }\n\n  .filter-item {\n    flex-direction: column;\n    margin-bottom: 12px !important;\n  }\n\n  .filter-item span {\n    display: none;\n  }\n\n  .filter-reset {\n    display: none;\n  }\n\n  .table-transaction {\n    overflow-x: auto;\n  }\n\n  .dashboard-chart {\n    display: none;\n  }\n\n  .dashboard-menu {\n    display: flex;\n  }\n\n  .dashboard-menu button:hover {\n    color: #fff;\n  }\n\n  .dashboard-menu button.active {\n    color: #fff;\n  }\n\n  .dashboard-menu button {\n    font-size: 16px;\n    width: 140px;\n    margin-bottom: 12px;\n    text-transform: uppercase;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
